import { apiSlice, ApiTags } from '../../../redux/api'
import { paramsToQuery } from '../../../../react/util/queries'
import { ApiMethods } from '../../../../react/api'

export const LandingPagesApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getLandingPage: builder.query({
      query: landingPageIdentifier => `landing/${landingPageIdentifier}`,
      providesTags: (result, error, landingPageIdentifier) => [{
        type: ApiTags.LandingPages,
        id: landingPageIdentifier
      }]
    }),
    getLandingPageJobs: builder.query({
      query: ({ landingPageIdentifier, ...params }) => `landing/${landingPageIdentifier}/jobs${paramsToQuery(params)}`,
      providesTags: (result, error, landingPageIdentifier) => [{
        type: ApiTags.LandingPages,
        id: landingPageIdentifier
      }]
    }),
    getLandingPageJob: builder.query({
      query: ({ landingPageIdentifier, jobPostingIdentifier }) => `landing/${landingPageIdentifier}/jobs/${jobPostingIdentifier}`,
      providesTags: (result, error, { landingPageIdentifier, jobPostingIdentifier }) => [
        {
          type: ApiTags.LandingPages,
          id: landingPageIdentifier
        },
        {
          type: ApiTags.JobPostings,
          id: jobPostingIdentifier
        }
      ]
    }),
    getLandingPageJobCategories: builder.query({
      query: (params) => `landing/job-categories${paramsToQuery(params)}`
    }),
    subscribeToLandingPage: builder.mutation({
      query: ({ landingPageIdentifier, ...body }) => ({
        url: `landing/${landingPageIdentifier}/subscribe`,
        method: ApiMethods.Post,
        body: body
      })
    })
  })
})

export const { useGetLandingPageQuery, useGetLandingPageJobsQuery, useGetLandingPageJobQuery, useGetLandingPageJobCategoriesQuery, useSubscribeToLandingPageMutation } = LandingPagesApi
